export default __webpack_public_path__ + "static/media/NickelfoxLogo.4dfde481.svg";